import { __assign, __extends } from "tslib";
import { Persona, PersonaSize } from '@fluentui/react';
import React from 'react';
import { SearchPersonaCoinStylesRound, SearchPersonaCoinStylesSqaure, SuggestionItemStyle } from './GlobalSearch.styles';
var SearchPersona = (function (_super) {
    __extends(SearchPersona, _super);
    function SearchPersona() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchPersona.prototype.render = function () {
        var _a = this.props, text = _a.text, secondaryText = _a.secondaryText, isPerson = _a.isPerson, imageUrl = _a.imageUrl, theme = _a.theme;
        var _isPerson = isPerson !== null && isPerson !== undefined ? isPerson : false;
        var personaProps = {
            text: text,
            secondaryText: secondaryText !== null && secondaryText !== undefined ? secondaryText : '',
            imageUrl: imageUrl !== null && imageUrl !== undefined ? imageUrl : ''
        };
        return (React.createElement(Persona, __assign({}, personaProps, { size: PersonaSize.size72, coinSize: 32, coinProps: { styles: _isPerson ? SearchPersonaCoinStylesRound : SearchPersonaCoinStylesSqaure }, styles: SuggestionItemStyle(theme), allowPhoneInitials: true })));
    };
    return SearchPersona;
}(React.Component));
export { SearchPersona };
//# sourceMappingURL=SearchPersona.js.map